import { DefaultApi, Configuration } from './generated-src';
import { AppSettings } from '../config/AppSettings';

export default function () {
    return new DefaultApi(new Configuration({ basePath: AppSettings().apiUrl }));
}
